import { useQuery } from '@tanstack/react-query'
import { useSession } from '~/components/user/SessionProvider'
import { isUserAnonymous } from '~/lib/auth/anonymous'
import { trpc } from '~/lib/trpc'

export function useUserIsAdmin() {
  const { session } = useSession()

  const { data: isAdmin = false } = useQuery(
    trpc.users.isAdmin.queryOptions(undefined, {
      enabled: !!session && !isUserAnonymous(session.user),
    })
  )

  return isAdmin
}
